import PATHS from 'app/routes/paths';
import accessibleByLicense from 'hocs/accessibleByLicense';
import accessibleByRole from 'hocs/accessibleByRole';
import { string } from 'utils/formatters';

const defaultRedirect = string.withDefaultPagination(
  PATHS.process.execution._()
);

const accessOrDefaultRedirect = accessibleByRole(defaultRedirect);

const licenseOrDefaultRedirect = accessibleByLicense(defaultRedirect);

export { accessOrDefaultRedirect, licenseOrDefaultRedirect };
